import { t as getFixedT } from "@/i18n";
import { BRAND, whatsappLink } from "@/lib/brand";
import type { SupportedLanguage } from "@/lib/site";
import { LeadForm } from "@/components/LeadForm";
import "./LeadFormSection.css";

interface LeadFormSectionProps {
  lang: SupportedLanguage;
}

/** #lead-form — 09-landing-page.md §2/§3: the page's primary conversion point. Desktop splits into
 * supporting trust copy (start) + the form itself (end); mobile stacks to a single column. */
export function LeadFormSection({ lang }: LeadFormSectionProps) {
  const t = getFixedT(lang);
  const bullets = t("leadFormSection.bullets", {
    returnObjects: true,
  }) as string[];

  return (
    <section
      id="lead-form"
      className="fa-lead-form-section"
      aria-labelledby="lead-form-heading"
    >
      <div className="fa-section-inner fa-lead-form-section__inner">
        <div className="fa-lead-form-section__copy">
          <h2 id="lead-form-heading">{t("leadFormSection.heading")}</h2>
          <p className="fa-lead-form-section__intro">
            {t("leadFormSection.intro")}
          </p>
          <ul className="fa-lead-form-section__bullets">
            {bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <div className="fa-lead-form-section__contact">
            <a href={`tel:${BRAND.phoneE164}`}>
              <span aria-hidden="true">☎</span> <bdi>{BRAND.phoneDisplay}</bdi>
            </a>
            <a
              href={whatsappLink(t("leadFormSection.whatsappMessage"))}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span aria-hidden="true">💬</span>{" "}
              {t("leadFormSection.whatsappLabel")}
            </a>
          </div>
        </div>
        <div className="fa-lead-form-section__form-wrap">
          <LeadForm lang={lang} />
        </div>
      </div>
    </section>
  );
}
